module.exports = __webpack_public_path__ + "img/Palestra6.ba48930e.jpg";